/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import localUpdate from "./utils/localUpdate" 
import saveExtended from "./utils/saveExtended"
import updateLandingData from "./utils/updateLandingData"

const WAIT_UPDATE_DELAY = 5
const UPDATE_INTERVAL   = 50
/* Protopia Ecosystem component */
export interface IUpdateSliderProps {
   
}
const UpdateSlider = (props: IUpdateSliderProps): JSX.Element => {
    const needUpdate            = useLandingStore((state: ILandingStore) => state.needUpdate )
    const currentLanding        = useLandingStore((state: ILandingStore) => state.currentLanding )  
    const width                 = useSyncState<number>(0)
    const ref                   = useRef<HTMLDivElement>(null)
    const update = () => { 
        const sliderElement = ref.current as HTMLDivElement
        width.set( ( width.get() + WAIT_UPDATE_DELAY ) ) 
        sliderElement.style.width = `${ width.get() }%`
        if( width.get() >= 100 ) {
            updateLandingData()
        }
    }
    useEffect(() => {
        let timer: any
        if(!!needUpdate) {
            localUpdate({ currentLanding }, "Update slider.")
            timer = setInterval(() => {
                update()
            }, UPDATE_INTERVAL)
        }
        else {
            clearInterval( timer )
            width.set( 0 ) 
        }
        return () => {
            clearInterval( timer )
            // localUpdate({ currentLanding }, "Update slider:")
        }
    }, [ needUpdate ])
    return <div className='landing-update-slider position-absolute bottom left w-100' >
        <div 
            className="landing-update-slider-slider" 
            ref={ref}
        />
    </div>
}
export default UpdateSlider